export default "__VITE_ASSET__CrD8TFi6__"